"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

export default function PromoBanners() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  return (
    <motion.section
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      className="space-y-8"
    >
      {/* Main promo banner */}
      <motion.div 
        variants={itemVariants}
        className="relative h-80 rounded-lg overflow-hidden"
      >
        <Image
          src="https://images.pexels.com/photos/2702805/pexels-photo-2702805.jpeg?auto=compress&cs=tinysrgb&w=1260"
          alt="Limited time offer"
          fill
          className="object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent" />
        <div className="absolute inset-0 flex items-center">
          <div className="ml-8 sm:ml-16 max-w-md">
            <h3 className="text-white text-3xl sm:text-4xl font-bold mb-3">Limited Time Offer</h3>
            <p className="text-white text-lg mb-6">
              Up to 30% off on selected premium spirits. Shop now while stocks last.
            </p>
            <Button asChild size="lg">
              <Link href="/offers">
                Shop Offers
              </Link>
            </Button>
          </div>
        </div>
      </motion.div>
      
      {/* Small promo banners */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <motion.div 
          variants={itemVariants}
          className="relative h-60 rounded-lg overflow-hidden"
        >
          <Image
            src="https://images.pexels.com/photos/3019019/pexels-photo-3019019.jpeg?auto=compress&cs=tinysrgb&w=1260"
            alt="Wine collection"
            fill
            className="object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute inset-0 flex items-end">
            <div className="p-6 max-w-xs">
              <h3 className="text-white text-xl font-bold mb-2">Premium Wine Collection</h3>
              <p className="text-white text-sm mb-4">
                Discover our curated selection of fine wines from around the world.
              </p>
              <Button asChild variant="secondary" size="sm">
                <Link href="/category/wine">
                  Explore Wines
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
        
        <motion.div 
          variants={itemVariants}
          className="relative h-60 rounded-lg overflow-hidden"
        >
          <Image
            src="https://images.pexels.com/photos/1269043/pexels-photo-1269043.jpeg?auto=compress&cs=tinysrgb&w=1260"
            alt="Craft beer"
            fill
            className="object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute inset-0 flex items-end">
            <div className="p-6 max-w-xs">
              <h3 className="text-white text-xl font-bold mb-2">Craft Beer Special</h3>
              <p className="text-white text-sm mb-4">
                Try our new range of craft beers from local Nigerian breweries.
              </p>
              <Button asChild variant="secondary" size="sm">
                <Link href="/category/beer">
                  Shop Beers
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}